import {isFeatureEnabled} from 'feature-flags';

import {featureFlags} from '@dms/feature-flags';

export const hasAclDocsWithPermission = (permission: boolean) => {
  if (!isFeatureEnabled(featureFlags.ACL_DOCUMENTS)) {
    return true;
  }

  return permission;
};
